import { render, staticRenderFns } from "./CodeRails.vue?vue&type=template&id=04af1f0a"
import script from "./CodeRails.vue?vue&type=script&lang=ts"
export * from "./CodeRails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports